/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EditionEnum } from './editionEnum';
import { CommerceModeEnum } from './commerceModeEnum';


export interface CommerceSpec { 
    edition?: EditionEnum;
    mode?: CommerceModeEnum;
}
export namespace CommerceSpec {
}


